import Icon, { Icons } from '@/components/elements/Icon';

export const ThemeToggle = ({
  theme,
  onChange,
}: {
  theme?: string;
  onChange: (v: string) => void;
}) => {
  return (
    <button
      className="transition-opacity text-gray-800"
      onClick={() => onChange(theme === 'light' ? 'dark' : 'light')}
    >
      <Icon name={theme === 'light' ? Icons.MOON : Icons.SUN} size={20} />
    </button>
  );
};

export default ThemeToggle;
